import { Membership } from "@bluefalcon/users-management-client-fetch";
import { falconClients } from "../clients/falcon.client";

export class MembershipsService {
    async grantMembership(tenantId: string, userId: string): Promise<Membership> {
        return falconClients.admin.addMembershipAdmin({
            tenantId,
            userId,
        });
    }

    async revokeMembership(membershipId: number): Promise<void> {
        return falconClients.admin.revokeMembershipAdmin({
            membershipId,
        });
    }
}